/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useRef } from 'react';
import {
  Col,
  Row,
  Form,
  Button,
  ButtonGroup,
  InputGroup,
  Dropdown,
} from 'react-bootstrap';
import { CheckIcon } from '@heroicons/react/solid';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import moment from "moment-timezone";
import { useBreakpoint } from '@vlinder-web/breakpoint-hook-widget-react';

export interface ISettingsCompProps {
  searchPlaceholderText?: string;
  searchPaymentFilter?: {
    value: string;
    label: string;
  }[];
  searchStatusFilter?: {
    value: string;
    label: string;
  }[];
  typeOfSearch?: {
    value: string;
    label: string;
  }[];
  onSearchValue?(name: string): void;
  onStatusFilter?(value: string): void;
  onPaymentFilter?(value: string): void;
  settingsEntriesLabel?: string;
  onApplyFilter?(filterData: any, statusFilter: any,  paymentFilter: any,
    startDate: any,
    endDate: any): void;
  onClearFilter?(): void;
  applyLabel?: string;
  clearLabel?: string;
  typeStyle?: any;
  settingsEntries?: {
    value: string;
    label: string;
  }[];
  onSettingEntryChange(value: string): void;
  downloadCsvReport?(filter?: any): void;
}

export const SettingsComp = ({
  searchPlaceholderText,
  searchPaymentFilter,
  searchStatusFilter,
  typeOfSearch,
  applyLabel,
  clearLabel,
  typeStyle,
  onSettingEntryChange,
  onApplyFilter,
  onClearFilter,
  downloadCsvReport
}: ISettingsCompProps) => {
  console.log("seettingsprops",searchPaymentFilter)
  const breakpoint = useBreakpoint();
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [searchValue, setSearchValue] = useState('');
  const [statusFilter, setStatusFilter] = useState(0);
  const [paymentFilter, setPaymentFilter] = useState(0);
  const [settingEntry, setSettingEntry] = useState('10');
  const [typeFilter, setTypeFilter] = useState('');
  const [disableApply, setDisableApply] = useState(true);
  const startDatetimeRef = useRef(null);
  const endDatetimeRef = useRef(null);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
    console.log('set->', typeFilter, typeFilter !== '' && e.target.value);
    setDisableApply(
      (typeFilter === '' || newSearchValue === '') && !statusFilter && !paymentFilter
    );
    // if (onSearchValue) {
    //   onSearchValue(newSearchValue?.toLowerCase());
    // }
  };

  const getButtonMargin = () => {
    let _style: any = {};
    if (breakpoint === 'xs' || breakpoint === 'sm') {
      _style.marginTop = '15px';
    }
    return _style;
  };

  const changeTypeFilter = (e) => {
    console.log(`on change type`, e);
    const newTypeFilter = e.target.value;
    setTypeFilter(newTypeFilter);
    setDisableApply(
      (newTypeFilter === '' || searchValue === '') && !statusFilter && !paymentFilter
    );
  };

  const _getStatus = (status: string) => {
    switch (status) {
      case 'active':
        return 'ACC_CREATED';
      case 'invited':
        return 'INVITED';
      case 'suspended':
        return 'SUSPENDED';
      default:
        return null;
    }
  };

  const applyFilterAction = () => {
    let formattedStartDate: any, formattedEndDate: any;
    console.log("startDate==>", startDate, "EndDate==>", endDate)
    if (startDate) {
      const momentDate = moment(startDate).startOf("day");
      formattedStartDate = momentDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ");

    }
    if (endDate) {
      const momentDate = moment(endDate).endOf("day");
      formattedEndDate = momentDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    }
    let _data: any = {};
    if (typeFilter && searchValue) {
      _data[typeFilter] = searchValue;
    }

    onApplyFilter && onApplyFilter(_data, statusFilter,paymentFilter, formattedStartDate, formattedEndDate);
  };

  const changeStatusFilter = (e) => {
    console.log(`change value`, e.target.value);
    const newStatusFilter = e.target.value;
    setStatusFilter(newStatusFilter);
    setDisableApply(
      (typeFilter === '' || searchValue === '') && !newStatusFilter
    );
  };
  const changePaymentFilter = (e) => {
    const newPaymentFilter = e.target.value;
    setPaymentFilter(newPaymentFilter);
    setDisableApply(
      (typeFilter === '' || searchValue === '') && !newPaymentFilter
    );
  };

  const changeSettingEntry = (e) => {
    setSettingEntry(e);
    if (onSettingEntryChange) {
      onSettingEntryChange(e);
    }
  };

  const clearFilter = () => {
    setSearchValue('');
    setStatusFilter(0);
    setPaymentFilter(0);
    setDisableApply(true);
    setTypeFilter('');
    onClearFilter && onClearFilter();
    setStartDate(undefined)
    setEndDate(undefined)
    clearStartDatetimeInput()
    clearEndDatetimeInput()
  };


  const clearStartDatetimeInput = () => {
    if (startDatetimeRef && startDatetimeRef.current) {
      startDatetimeRef.current.state.inputValue = "";
      startDatetimeRef.current.state.selectedDate = null;
      startDatetimeRef.current.forceUpdate();
    }
  };
  const clearEndDatetimeInput = () => {
    if (endDatetimeRef && endDatetimeRef.current) {
      endDatetimeRef.current.state.inputValue = "";
      endDatetimeRef.current.state.selectedDate = null;
      endDatetimeRef.current.forceUpdate();
    }
  };

  const onStartDateChange = (e: any) => {
    setStartDate(e)
    setDisableApply(false);
  };
  const onEndDateChange = (e: any) => {
    setEndDate(e)
    setDisableApply(false);
  };
  const _downloadCsvReport = () => {
    downloadCsvReport && downloadCsvReport();
  };
  const _getCheckIcon = (value: any) => {
    if (value && value === settingEntry) {
      return <CheckIcon className="icon icon-xxs ms-auto" />;
    }
    return <></>;
  };

  const isValidDate = (currentDate: moment.Moment) => {
    const now = moment().startOf('day');
    return currentDate.isSameOrBefore(now);
  };
  console.log("asdfasfdasdfas",searchPaymentFilter);
  return (
    <div className="table-settings mb-4">
      <Row className="justify-content-between align-items-center">
        <Col xs={12} lg={8} className="d-md-flex">
          <InputGroup className="me-2 me-lg-4 fmxw-500">
            <Form.Select
              value={typeFilter}
              style={typeStyle}
              // className="fmxw-150 d-none d-md-inline"
              onChange={changeTypeFilter}
            >
              <option value="">Select Type</option>
              {typeOfSearch?.map((status, index) => (
                <option
                  key={`option-${status?.value}-${index}`}
                  value={status?.value}
                >
                  {status?.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control
              type="text"
              placeholder={searchPlaceholderText}
              value={searchValue}
              onChange={changeSearchValue}
            />
          </InputGroup>
          {/* <Datetime
            inputProps={{
              className: 'fmxw-200 d-none d-md-inline',
              placeholder: 'Select Start Date',
              style: { fontSize: "10px", color: "#717a73", border: '1px solid #ccc', borderRadius: '10px', padding: '8px', marginLeft: "3%" },
            }}
            ref={startDatetimeRef}
            closeOnSelect={true}
            isValidDate={isValidDate}
            value={startDate || undefined}
            dateFormat="DD/MM/YYYY"
            onChange={(date: any) => onStartDateChange(date)}
            timeFormat={false}
          />
          <div style={{ marginLeft: '1%', marginRight: "10px" }}>
            <Datetime
              inputProps={{
                className: 'fmxw-200 d-none d-md-inline',
                placeholder: 'Select End Date',
                style: { fontSize: "10px", color: "#717a73", border: '1px solid #ccc', borderRadius: '10px', padding: '8px' },
              }}
              ref={endDatetimeRef}
              closeOnSelect={true}
              isValidDate={isValidDate}
              value={endDate || undefined}
              dateFormat="DD/MM/YYYY"
              onChange={(date: any) => onEndDateChange(date)}
              timeFormat={false}
            />
          </div> */}
          {searchPaymentFilter && (
            <Form.Select
              value={paymentFilter}
              className="fmxw-200 d-none d-md-inline"
              onChange={changePaymentFilter}
            >
              {searchPaymentFilter?.map((payment, index) => (
                <option
                  key={`option-${payment?.value}-${index}`}
                  value={payment?.value}
                >
                  {payment?.label}
                </option>
              ))}
            </Form.Select>
          )}
          {searchStatusFilter && (
            <Form.Select
              value={statusFilter}
              className="fmxw-200 d-none d-md-inline"
              onChange={changeStatusFilter}
            >
              {searchStatusFilter?.map((status, index) => (
                <option
                  key={`option-${status?.value}-${index}`}
                  value={status?.value}
                >
                  {status?.label}
                </option>
              ))}
            </Form.Select>
          )}
          <Button
            variant="secondary"
            size="sm"
            className="ms-3"
            disabled={disableApply}
            onClick={applyFilterAction}
            style={getButtonMargin()}
          >
            {applyLabel}
          </Button>
          {!disableApply ? (
            <Button
              variant="primary"
              size="sm"
              className="ms-3"
              onClick={clearFilter}
              style={getButtonMargin()}
            >
              {clearLabel}
            </Button>
          ) : null}
          <Button
            variant="info"
            size="sm"
            className="ms-3 animate-up-2"
            onClick={_downloadCsvReport}
            style={{...getButtonMargin(),minWidth:'150px',maxWidth:'300px'}}
          >
            {/* <div className="d-flex"> */}
              {"Download Report"}
            {/* </div> */}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

SettingsComp.defaultProps = {
  searchPlaceholderText: 'Search payments',
  settingsEntriesLabel: 'Show',
  applyLabel: 'Apply',
  clearLabel: 'Clear',
  typeOfSearch: [
    {
      label: 'Payment ID',
      value: 'paymentId',
    },
    // {
    //   label: 'Organization Name',
    //   value: 'orgName',
    // },
    {
      label: 'Application ID',
      value: 'appId',
    },
  ],
  typeStyle: {
    maxWidth: '140px',
  },
};
